<!-- src/components/TagsView.vue -->
<template>
  <div class="tags-view-container">
    <el-scrollbar style="height: 100%;" wrap-class="tags-view-wrapper" wrap-style="width: 100%; white-space: nowrap;" view-style="width: 100%;">

      <el-tag style="margin-right: 10px; height: 30px; "
        v-for="tag in visitedViews"
        :key="tag.path"
        type="success"
        closable
        @close="handleClose(tag)"
        :class="{'active': isActive(tag)}"
        @click="handleClick(tag)"
      >
        {{ tag.title }}
      </el-tag>


    </el-scrollbar>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: 'TagsView',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const visitedViews = ref([]);

    const cachedViews = ref([]);

    // Add a new view
    const addView = (view) => {
      if (visitedViews.value.some((v) => v.path === view.path)) return;
      visitedViews.value.push(view);
      cachedViews.value.push(view);
    };

    // Remove a view
    const removeView = (view) => {

      for(let i=0; i<visitedViews.value.length; i++){
        if(view.path == visitedViews.value[i].path){
          visitedViews.value.splice(i, 1);
          break;
        }
      }

      // TODO 有bug
      // for (const [i, v] of visitedViews.value.entries()) {
      //   if (v.path === view.path) {
      //     visitedViews.value.splice(i, 1);
      //     if (i === visitedViews.value.length) {
      //       visitedViews.value.pop();
      //     }
      //     break;
      //   }
      // }
    };

    // Handle tag click
    const handleClick = (tag) => {
      const latestView = visitedViews.value.find((v) => v.path === tag.path);
      if (latestView) {
        router.push(latestView.fullPath).catch((err) => {});
      }
    };

    // Handle tag close
    const handleClose = (tag) => {
      
      removeView(tag);

      const latestUrl = visitedViews.value[visitedViews.value.length - 1];
      if (latestUrl && latestUrl.path !== route.path) {
        router.push(latestUrl.fullPath).catch((err) => {});
      } else if (visitedViews.value.length === 0) {
        router.push('/').catch((err) => {});
      }

    };

    // Check if a tag is active
    const isActive = (tag) => tag.path === route.path;

    // Watch route changes
    watch(
      () => route.path,
      (newPath) => {
        const tag = {
          title: route.meta.title || 'untitled',
          path: newPath,
          fullPath: route.fullPath,
        };
        if (!visitedViews.value.some((v) => v.path === newPath)) {
          addView(tag);
        }
      },
      { immediate: true }
    );

    return {
      visitedViews,
      handleClick,
      handleClose,
      isActive,
    };
  },
};
</script>

<style scoped>
.tags-view-container {
  display: flex;
  flex-wrap: wrap;
  padding: 4px 0px;
  background-color: #fff;
  /* border-bottom: 1px solid #ebeef5; */
}

.tags-view-wrapper {
  display: flex;
  flex-wrap: wrap;

}

.el-tag {
  background-color: #fff;
  color: #606266;
 
}
.el-tag:hover{
  cursor: pointer;
 
}
.el-tag.active {
  background-color: #42b983;
  color: #fff;
}
</style>